module.exports = import("https://esm.sh/@tiptap/extension-color@2.4.0");;